import { actionTypes } from 'app/types/action_types';

const initialState = {
  displaySets: [],
  hero: {},
  showTitles: false,
  trendingSearchTerms: [],
  popularCategories: {
    featured: [],
    inspiredPills: [],
  },
};

const mapInitialPayloadAction = (state, payload) => ({
  ...state,
  displaySets: payload.displaySets,
  heroData: payload.heroData,
  showTitles: payload.showTitles,
  trendingSearchTerms: payload.trendingSearchTerms,
  popularCategories: payload.popularCategories,
});

const videoTemplatePageReducer = (state, action) => {
  switch (action.type) {
    case actionTypes.INITIALIZE:
      return mapInitialPayloadAction(state || initialState, action.payload);
    default:
      return state || initialState;
  }
};

export default videoTemplatePageReducer;
